import React, { useState, useEffect } from "react";
import { motion } from 'framer-motion';
import "../../styles/common.css";
import "../../styles/cta.css";

function CtaLayout({ children }) {
  const fadeInSlideUpTitle = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, ease: 'easeOut' } },
  };

  const [hasAnimated, setHasAnimated] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem("hasAnimated")) {
      setHasAnimated(true);
    }
  }, []);
  const handleAnimationComplete = () => {
    sessionStorage.setItem("hasAnimated", "true");
    setHasAnimated(true);
  };

  return (
    <>
      <section className='cta'>
        <motion.div className="title" variants={fadeInSlideUpTitle} initial={hasAnimated ? "visible" : "hidden"} whileInView="visible" viewport={{ once: false, amount: 0.2 }} onAnimationComplete={handleAnimationComplete}>
          <p className='title-lead'>CONTACT</p>
          <h2>Contact Us</h2>
        </motion.div>
        <div className='cta-box flex'>
          {children}
          <div className='cta-buttonArea'>
            <div className='button-arrow button-icon button-gradation button-contact'>
              <a href="/en/contact"><span>Start with a free consultation</span></a>
            </div>
            {/* <div className='button-arrow button-icon button-white button-document'>
              <a href="/"><span>Request Materials</span></a>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default CtaLayout;
